export const CARD_DISPLAY_DEBOUNCE_MS = 300;

export type { CardDisplayResponse as CardDisplay } from '../infrastructure/paymentMiddlewareClient';

/**
 * Prefix worth asking the backend about. One digit is enough for Visa. Two cover Amex,
 * Mastercard 51-55 and Diners. Four cover the Mastercard 2-series. Six reads the BIN window.
 * Seven and eight keep that window. Nine picks the single range, so crédito and débito that
 * share the first six can diverge.
 */
export function displayQuery(digits: string): string | null {
  if (!digits) return null;
  if (digits.length >= 9) return digits.slice(0, 9);
  if (digits.length >= 6) return digits.slice(0, 6);
  if (digits.startsWith('4')) return digits;
  if (digits.length >= 2 && /^(34|37|36|5[1-5])/.test(digits)) return digits;
  if (digits.length >= 4 && /^2[2-7]/.test(digits)) {
    const prefix = Number(digits.slice(0, 4));
    if (prefix >= 2221 && prefix <= 2720) return digits;
  }
  return null;
}
